<template>
  <v-container class="fill-height container--fluid">
    <v-row align="center" justify="center">
      <v-col style="max-width: 500px">
        <v-fade-transition mode="out-in">
          <TheNewPasswordForm v-if="mode === 'new'" 
            @error="onError" 
            @passwordUpdated="passwordUpdated"
            @cancel="mode = null"
          />
          <TheForgotPasswordForm v-else-if="mode === 'forgot'" 
            @error="onError" 
            @submitted="emailSubmitted" 
            @cancel="mode = null"
          />
          <TheLoginForm v-else 
            @error="onError" 
            @logged="logged" 
            @forgotPassword="mode = 'forgot'"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TheLoginForm from '@/components/Login/TheLoginForm'
import TheNewPasswordForm from '@/components/Login/TheNewPasswordForm'
import TheForgotPasswordForm from '@/components/Login/TheForgotPasswordForm'
import routeNames from '@/router/routeNames'
export default {
  components: { TheLoginForm, TheNewPasswordForm, TheForgotPasswordForm },
  data: () => ({
    mode: null
  }),
  methods: {
    passwordUpdated () {
      this.$store.dispatch('successMessage', this.$t('LoginPage.Success.updatedPassword'))
      this.$router.replace({ name: routeNames.login })
      this.mode = null
    },
    emailSubmitted () {
      this.$store.dispatch('successMessage', this.$t('LoginPage.Success.resetPasswordEmail'))
      this.mode = null
    },
    logged () {
      this.$store.getters['auth/isAdmin'] ? this.$router.push({ name: routeNames.brands }) : this.$router.push({ name: routeNames.user.myHome })
      
    },
    onError (error) {
      this.$store.dispatch('errorMessage', error)
    }
  },
  created () {
    if (this.$route.query.token) {
      this.mode = 'new'
    }
  }
}
</script>